/**
 * SpecialTestsCard — v1.1 refactor.
 * Lifted out of ObjectiveAssessment.jsx. Evidence-based special tests table
 * (test catalogue from `lib/pe-options`, side, result, reference sensitivity,
 * notes). Pure presentational — parent owns state.
 */
import React from 'react';
import { Trash2 } from 'lucide-react';
import SmartSelect from './SmartSelect';
import { ALL_SPECIAL_TESTS, POS_NEG } from '../lib/pe-options';

const SIDES = ['L','R','Both','N/A'];

export default function SpecialTestsCard({
  rows = [], patient_id,
  updRow, addRow, delRow, appendScribeRow,
  Section, GridTable, AddBtn,
}) {
  return (
    <Section title="Special evidence-based tests" testid="sec-special"
             scribeKey="special_tests" patientId={patient_id}
             onScribeText={appendScribeRow('special_tests', (text) => ({
               region: '', name: 'AI · ' + text.slice(0, 60), result: 'positive',
               notes: text, reference: '',
             }))}>
      <GridTable cols={['Test','Side','Result','Reference / sensitivity','Notes']}>
        {(rows || []).map((r, i) => (
          <tr key={i} data-testid={`special-${i}`}>
            <td>
              <SmartSelect value={r.test || ''}
                           onChange={(v) => updRow('special_tests', i, { test: v })}
                           options={ALL_SPECIAL_TESTS.map(t => ({
                             value: t.value, label: `${t.value} · ${t.region}`, ref: t.ref,
                           }))}
                           placeholder="Pick test or Other…"
                           testid={`special-${i}-test`}
                           compact/>
            </td>
            <td>
              <select className="input" value={r.side || ''}
                      onChange={e => updRow('special_tests', i, { side: e.target.value })}>
                {['', ...SIDES].map(s => <option key={s}>{s}</option>)}
              </select>
            </td>
            <td>
              <SmartSelect value={r.result || ''}
                           onChange={(v) => updRow('special_tests', i, { result: v })}
                           options={POS_NEG}
                           placeholder="+ / − / equivocal"
                           testid={`special-${i}-result`}
                           compact/>
            </td>
            <td>
              <input className="input" value={r.reference || ''}
                     onChange={e => updRow('special_tests', i, { reference: e.target.value })}
                     placeholder="Sn 0.78 / Sp 0.65"/>
            </td>
            <td>
              <input className="input" value={r.notes || ''}
                     onChange={e => updRow('special_tests', i, { notes: e.target.value })}/>
            </td>
            <td className="print:hidden">
              <button onClick={() => delRow('special_tests', i)} className="text-[#B83A3A] p-1">
                <Trash2 className="w-4 h-4"/>
              </button>
            </td>
          </tr>
        ))}
      </GridTable>
      <AddBtn onClick={() => addRow('special_tests', {
        test: '', side: '', result: '', reference: '', notes: '',
      })} testid="add-special"/>
    </Section>
  );
}
